import Vue from 'vue'
import VueRouter from 'vue-router'
import Categories from '../views/Categories'
import Redirect from '../views/Redirect'
import Products from '../views/Products'
import Product from '../views/Product'
import ProductCombo from '../views/ProductCombo'
import Cart from '../views/Cart'
import IdentifyVisitor from '../views/IdentifyVisitor'
import Orders from "../views/Orders";
import Search from "../views/Search";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/categorias'
    },
    {
        path: '/categorias',
        name: 'categories',
        component: Categories
    },
    {
        path: '/:pdv(\\d+)/:number(\\d+)',
        name: 'redirect',
        component: Redirect,
    },
    {
        path: '/categoria/:id/produtos',
        name: 'products',
        component: Products,
        props: true
    },
    {
        path: '/produto/:id',
        name: 'product',
        component: Product,
        props: true
    },
    {
        path: '/combo/:id',
        name: 'product-combo',
        component: ProductCombo,
        props: true
    },
    {
        path: '/carrinho',
        name: 'cart',
        component: Cart,
        props: true
    },
    {
        path: '/identificando',
        name: 'identify',
        component: IdentifyVisitor,
        props: true
    },
    {
        path: '/meus-pedidos',
        name: 'myOrders',
        component: Orders,
        props: true
    },
    {
        path: '/pesquisar',
        name: 'search',
        component: Search,
        props: true
    },
    {
        path: "*",
        redirect: "/categorias"
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior() {
        document.getElementById('content').scrollIntoView();
    }
})
router.afterEach(() => {
    window.scrollTo(0,0);
})

export default router
